import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { AGENCY_DETAILS_STORE_KEY } from './data/agency-details-store.state';
import { AgencyDetailsReducer } from './data/agency-details-store.reducer';
import { AgencyDetailsEffects } from './data/agency-details-store.effects';

@NgModule({
  imports: [CommonModule, StoreModule.forFeature(AGENCY_DETAILS_STORE_KEY, AgencyDetailsReducer), EffectsModule.forFeature([AgencyDetailsEffects])],
})
export class SharedFeatureAgencyDetailsModule {}
